import type { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { INITIAL_TARIFF_CODE_COL_DEF } from "../TariffCode/TariffCodeColumnDefinition";

const excludeFieldsFromTariffCode = ["tarSchemeCode", "tarNature", "percentage", "includeTputInd", "activeInd"]
export const INITIAL_TARIFF_CODE_BY_COMP_DTL_COL_DEF: any[] = INITIAL_TARIFF_CODE_COL_DEF.filter(col => !excludeFieldsFromTariffCode.includes(col.field))?.map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, [], [], [], cellRenderers);
});